export const TWO_FACTOR_KEY = 'twoFactor';
export const CONFIRM_TO_LOGIN_KEY = 'confirmToLogin';